import React, { useState } from 'react';
import { FaTimes, FaUpload } from 'react-icons/fa';
import { toast } from 'react-toastify';

const ImageUploadModal = ({ isOpen, setIsOpen, protocolId, onUpload }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFileChange = e => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      toast.warning('Por favor, selecione um arquivo de imagem válido.');
      setSelectedFile(null);
      setImagePreview(null);
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!selectedFile) {
      toast.warning('Por favor, selecione uma imagem.');
      return;
    }

    setIsSubmitting(true);

    try {
      // Converter arquivo para base64
      const reader = new FileReader();
      reader.onload = async () => {
        const base64 = reader.result;
        await onUpload(protocolId, base64);
        setIsOpen(false);
        setSelectedFile(null);
      };
      reader.readAsDataURL(selectedFile);
    } catch (error) {
      toast.error('Erro ao processar a imagem.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleRemoveImage = () => {
    setSelectedFile(null);
    setImagePreview(null);
  };

  const handleClose = () => {
    if (isSubmitting) return;
    setIsOpen(false);
    setSelectedFile(null);
    setImagePreview(null);
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: 8,
          padding: 20,
          maxWidth: 400,
          width: '100%',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 20,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <FaUpload size={24} color="#01579b" />
            <h3 style={{ margin: 0, marginLeft: 10 }}>Enviar Imagem</h3>
          </div>
          <button
            type="button"
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
            }}
            disabled={isSubmitting}
          >
            <FaTimes size={18} color="#e53935" />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 20 }}>
            <label
              htmlFor="imageFile"
              style={{ display: 'block', marginBottom: 8 }}
            >
              Selecione uma imagem
            </label>
            <input
              id="imageFile"
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              disabled={isSubmitting}
              style={{ width: '100%' }}
            />
            {imagePreview && (
              <div
                style={{
                  marginTop: 10,
                  position: 'relative',
                  display: 'inline-block',
                }}
              >
                <img
                  src={imagePreview}
                  alt="Preview"
                  style={{
                    maxWidth: '100%',
                    maxHeight: 200,
                    borderRadius: 8,
                    border: '1px solid #ccc',
                  }}
                />
                <button
                  type="button"
                  onClick={handleRemoveImage}
                  style={{
                    position: 'absolute',
                    top: 5,
                    right: 5,
                    backgroundColor: '#e53935',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '50%',
                    width: 24,
                    height: 24,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  title="Remover imagem"
                >
                  <FaTimes size={12} />
                </button>
              </div>
            )}
            {selectedFile && <p>Arquivo selecionado: {selectedFile.name}</p>}
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
            <button
              type="button"
              onClick={handleClose}
              disabled={isSubmitting}
              style={{
                padding: '8px 16px',
                backgroundColor: '#f5f5f5',
                border: '1px solid #ccc',
                borderRadius: 4,
                cursor: 'pointer',
              }}
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={isSubmitting || !selectedFile}
              style={{
                padding: '8px 16px',
                backgroundColor: '#01579b',
                color: '#fff',
                border: 'none',
                borderRadius: 4,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <FaUpload />
              {isSubmitting ? 'Enviando...' : 'Enviar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ImageUploadModal;
